export function isIOSAgent() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipod|ipad/.test( userAgent );
}
